var isInputNumber=function(input){return typeof input!=="undefined"&&!Number.isNaN(Number(input.replace(",",".")))};export default isInputNumber;
//# sourceMappingURL=isInputNumber.js.map